import { render } from "./PerformanceDetail.vue?vue&type=template&id=be9a26d8&ts=true"
import script from "./PerformanceDetail.vue?vue&type=script&lang=ts"
export * from "./PerformanceDetail.vue?vue&type=script&lang=ts"

import "./PerformanceDetail.vue?vue&type=style&index=0&id=be9a26d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__